var exports = {
  "kL": "ProfileTypeSelector.module__container___YTR3c1",
  "r9": "ProfileTypeSelector.module__disabled___YTR3c1",
  "h_": "ProfileTypeSelector.module__description___YTR3c1",
  "By": "ProfileTypeSelector.module__guildOption___YTR3c1",
  "mN": "ProfileTypeSelector.module__guildOptionGlobal___YTR3c1",
  "XN": "ProfileTypeSelector.module__guildAvatar___YTR3c1",
  "oM": "ProfileTypeSelector.module__guildAvatarPlaceholder___YTR3c1",
  "p2": "ProfileTypeSelector.module__guildOptionLabel___YTR3c1",
};

module.exports = exports;
